import React from 'react';
import { useTranslation } from 'react-i18next';

export const AdminCallout: React.FC = () => {
  const { t } = useTranslation();
  
  return (
    <div className="bg-gray-600 text-white py-2.5 px-5 text-center font-bold w-full z-10">
      {t('admin.view_message', 'Admin View - You are seeing all available tickets')}
    </div>
  );
}; 